import Litepicker from 'litepicker';
import { t } from '../../common/translations';
import {
  addDays,
  dayDatesBetween,
  format,
  inclusions,
  parse,
  daysDiff,
  SIMPLE_DATE_FORMAT,
  verifyBlockedDates,
  lastBlockedDate
} from '../../common/dates';
import { open as openMobileCalendarModal, close as closeMicroModal } from './modalHandler';
import { updateMobilePreview } from '../MobileCalendarModal/summaryInfo';
import { datesToInputs, inputsToCalendar } from '../MobileCalendarModal/datesHelpers';
import { getElement } from '../../common/asyncElementGetter';

let datePickCheckoutMobile = null;
let maxDate = null;
let datePickCheckinMobile = null;

async function modalReservationForm({ document }, { http }, searchDateFilter = false) {
  let preloadUrl = null;
  let availibilityWindowSize = null;
  let minimumStay = null;
  let minDateParsed = null;
  let blockedDates = [];
  let blockedCheckInDates = [];
  let firstAvailableDateDueMinimumStay = null;
  let datesFromTodayUntilFirstAvailableDate = null;
  let checkInEl = null;
  let checkOutEl = null;
  let checkInTextDivEl = null;
  let checkInTextEl = null;
  let checkInLabelEl = null;
  let checkOutTextDivEl = null;
  let checkOutTextEl = null;
  let checkOutLabelEl = null;
  let submitDatesButtonEl = null;
  let clearDatesButtonEl = null;
  let checkInTabEL = null;
  let checkOutTabEL = null;
  let minParsed = null;
  let searchedDatesCheckIn = null;
  let searchedDatesCheckOut = null;
  let moveIn = null;
  let moveOut = null;
  const today = new Date();

  if (!searchDateFilter) {
    const breakdownPropsEl = document.querySelector('#breakdown-props');
    preloadUrl = breakdownPropsEl.getAttribute('data-preload-url');
    availibilityWindowSize = parseInt(breakdownPropsEl.getAttribute('data-availibility-window-size'));
    minimumStay = parseInt(breakdownPropsEl.getAttribute('data-minimum-stay') || '0');
  }

  const locale = document.querySelector('html').getAttribute('lang');
  const checkInInput = document.querySelector('#search_check_in');
  const checkOutInput = document.querySelector('#search_check_out');
  const seeDatesButtonEls = await getElement('.reservation-sticky-submit', true, true, 500, 30);
  const datesButton = await getElement('.search-select-dates', false, true, 500, 30);

  const createDatePicker = () => {
    minimumStay = parseInt(`${t('apartment_page.js.modal.minimum_stay')}`);
    document.querySelector('.check-out-container').classList.add('display-none');
    const datePickCheckinMobileEl = document.querySelector('#mobile-checkin-date');
    datePickCheckinMobile = new Litepicker({
      element: datePickCheckinMobileEl,
      inlineMode: true,
      singleMode: true,
      onSelect: function(date1) {
        selectCheckinDatesHandler(date1);
      }
    });

    const datePickCheckoutMobileEl = document.querySelector('#mobile-checkout-date');
    datePickCheckoutMobile = new Litepicker({
      element: datePickCheckoutMobileEl,
      inlineMode: true,
      singleMode: true,
      onSelect: function(date2) {
        selectCheckoutDatesHandler(date2);
      }
    });
    readElements(searchDateFilter);
    preloadMobile();
  };

  const selectCheckinDatesHandler = (dateCheckIn) => {
    const checkOut = datePickCheckoutMobile.getDate();
    const newMinDate = addDays(dateCheckIn, minimumStay);
    const newMaxDate = verifyBlockedDates(blockedDates, dateCheckIn);
    checkInTextEl.innerText = format(dateCheckIn, 'D MMMM YYYY');
    moveIn = document.querySelector('.check_in');
    moveIn.classList.add('wrapper-adjust');
    datePickCheckoutMobile.setOptions({
      minDate: newMinDate,
      maxDate: newMaxDate
    });
    if (!checkOut || daysDiff(newMinDate, checkOut) < 0) {
      datePickCheckoutMobile.setOptions({
        startDate: newMinDate
      });
      document.querySelector('.check-in-container').classList.add('display-none');
      document.querySelector('.check-out-container').classList.remove('display-none');
      checkInEl.classList.remove('selected');
      checkInLabelEl.classList.add('display-none');
      checkInTextDivEl.classList.remove('display-none');
      checkOutLabelEl.classList.remove('display-none');
      checkOutTextDivEl.classList.add('display-none');
      checkOutEl.classList.add('selected');
      submitDatesButtonEl.disabled = true;
      datePickCheckoutMobile.clearSelection();
      minParsed = Date.parse(addDays(newMinDate, 14).toDateString());
      if (document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
        document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
      } else {
        minParsed = Date.parse(addDays(newMinDate).toDateString());
        if (document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
          document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
        }
      }
      showCheckOutMessage();
      if (searchDateFilter) {
        showReservationConfirmSubmit();
        submitDatesButtonEl.disabled = false;
      }
    }
  };

  const selectCheckoutDatesHandler = (dateCheckOut) => {
    showCheckOutMessage();
    moveOut = document.querySelector('.check_out');
    moveOut.classList.add('wrapper-adjust');
    checkOutTextEl.innerText = format(dateCheckOut, 'D MMMM YYYY');
    checkOutLabelEl.classList.add('display-none');
    checkOutTextDivEl.classList.remove('display-none');
    checkInEl.classList.remove('selected');
    checkOutEl.classList.add('selected');
    if (!searchDateFilter) {
      goToUpdateMobilePreview();
    }
  };

  const checkScrollToMinDate = () => {
    if (minParsed && document.querySelector('.check-out-container a[data-time="' + minParsed + '"]')) {
      document.querySelector('.check-out-container a[data-time="' + minParsed + '"]').scrollIntoView(false);
    }
  };

  const readElements = (searchDateFilter) => {
    checkInEl = document.querySelector('#check-in-tab');
    checkOutEl = document.querySelector('#check-out-tab');
    checkInTextDivEl = document.querySelector('.calendar-range__selection-value-check_in');
    checkInTextEl = document.querySelector('.value_check_in');
    checkInLabelEl = document.querySelector('.select_check_in');
    checkOutTextDivEl = document.querySelector('.calendar-range__selection-value-check_out');
    checkOutTextEl = document.querySelector('.value_check_out');
    checkOutLabelEl = document.querySelector('.select_check_out');
    submitDatesButtonEl = document.querySelector('#reservation-confirm__submit');
    clearDatesButtonEl = document.querySelector('.clear-dates');
    const closeDatesModalBtnEl = document.querySelector('#close-calendar-modal');
    closeDatesModalBtnEl.removeEventListener('click', closeMicroModal);
    closeDatesModalBtnEl.addEventListener('click', closeMicroModal);
    clearDatesButtonEl.addEventListener('click', clearCalendarDates);
    submitDatesButtonEl.addEventListener('click', goToUpdateMobilePreview);
    checkInTabEL = document.querySelector('#check-in-tab');
    checkInTabEL.addEventListener('click', checkInTabHandler);
    checkOutTabEL = document.querySelector('#check-out-tab');
    checkOutTabEL.addEventListener('click', checkOutTabHandler);
    const btnPrevMonthEl = document.querySelector('.check-out-container .button-previous-month');
    btnPrevMonthEl.addEventListener('click', checkScrollToMinDate);
    if (searchDateFilter) {
      const submitDatesButtonElText = document.querySelector('.submit_button_text');
      const submitWrapper = document.querySelector('.submit-wrapper');
      submitWrapper.classList.remove('display-none');
      submitDatesButtonElText.innerText = `${t('apartment_page.js.modal.apply')}`;
    }
  };

  const goToUpdateMobilePreview = () => {
    if (datePickCheckinMobile.getDate() && datePickCheckoutMobile.getDate() && !searchDateFilter) {
      updateMobilePreview(datePickCheckinMobile.getDate(), datePickCheckoutMobile.getDate(), http);
    }

    if (searchDateFilter) {
      const form = document.querySelector('.new_search');
      const checkIn = datePickCheckinMobile.getDate();
      const checkOut = datePickCheckoutMobile.getDate();
      const dates = { checkIn, checkOut };

      datesToInputs(dates, { checkInInput, checkOutInput });
      form.submit();
    }
  };

  const clearCalendarDates = () => {
    document.querySelector('.check-out-container').classList.add('display-none');
    document.querySelector('.check-in-container').classList.remove('display-none');
    checkInLabelEl.classList.remove('display-none');
    checkInTextDivEl.classList.add('display-none');
    moveIn = document.querySelector('.check_in');
    moveOut = document.querySelector('.check_out');
    moveIn.classList.remove('wrapper-adjust');
    moveOut.classList.remove('wrapper-adjust');
    datePickCheckinMobile.clearSelection();
    datePickCheckoutMobile.clearSelection();
    showCheckInMessage();
    document.querySelector('.datepicker-loader').style.display = 'none';
    if (minParsed) {
      document.querySelector('a[data-time="' + minDateParsed + '"]').scrollIntoView(false);
    }
    checkOutEl.classList.remove('selected');
    checkInEl.classList.add('selected');
    checkOutLabelEl.classList.remove('display-none');
    checkOutTextDivEl.classList.add('display-none');
  };

  const preloadMobile = async() => {
    let unavailableDates = [];
    let unavailableMoveInDates = [];

    if (!searchDateFilter) {
      const { data: { unavailable_dates: _unavailableDates, unavailable_move_in_dates: _unavailableMoveInDates, reservations } } = await http.get(preloadUrl);

      unavailableDates = _unavailableDates.map(({ day }) => parse(day, SIMPLE_DATE_FORMAT));
      unavailableMoveInDates = _unavailableMoveInDates.map(({ day }) => parse(day, SIMPLE_DATE_FORMAT));

      reservations.forEach(({ start_date: startDate, end_date: endDate }) => {
        const dates = dayDatesBetween(
          parse(startDate, SIMPLE_DATE_FORMAT),
          parse(endDate, SIMPLE_DATE_FORMAT),
          inclusions.BOTH
        );
        dates.forEach(date => {
          unavailableDates.push(date);
        });
      });
    }
    firstAvailableDateDueMinimumStay = parse(window.nextAvailableDay);
    datesFromTodayUntilFirstAvailableDate = dayDatesBetween(today, firstAvailableDateDueMinimumStay);
    blockedDates = unavailableDates.concat(datesFromTodayUntilFirstAvailableDate);
    blockedCheckInDates = blockedDates.concat(unavailableMoveInDates);
    const lastBlockDate = lastBlockedDate(blockedDates);

    if (!searchDateFilter) {
      maxDate = addDays(lastBlockDate || firstAvailableDateDueMinimumStay, availibilityWindowSize);
    }

    if (searchDateFilter) {
      const searchedDates = inputsToCalendar({ checkInInput, checkOutInput });
      searchedDatesCheckIn = searchedDates.checkIn;
      searchedDatesCheckOut = searchedDates.checkOut;
      if (searchedDatesCheckIn) {
        selectCheckinDatesHandler(searchedDatesCheckIn);
      }

      if (searchedDatesCheckOut) {
        selectCheckoutDatesHandler(searchedDatesCheckOut);
      }

      checkInTabHandler();
    }
    const checkInDate = inputsToCalendar({ checkInInput, checkOutInput });

    minDateParsed = Date.parse(firstAvailableDateDueMinimumStay.toDateString());
    datePickCheckinMobile.setOptions({
      lang: locale,
      numberOfMonths: 2,
      numberOfColumns: 1,
      hotelMode: true,
      firstDay: 0,
      startDate: checkInDate.checkIn || firstAvailableDateDueMinimumStay.toDateString(),
      mobileFriendly: true,
      minDate: firstAvailableDateDueMinimumStay.toDateString(),
      maxDate: maxDate,
      bookedDays: blockedCheckInDates
    });

    datePickCheckoutMobile.setOptions({
      lang: locale,
      numberOfMonths: 2,
      numberOfColumns: 1,
      hotelMode: true,
      firstDay: 0,
      startDate: searchedDatesCheckOut,
      minDate: addDays(today, minimumStay),
      mobileFriendly: true,
      bookedDays: blockedDates
    });
    showCheckInMessage();
    document.querySelector('.datepicker-loader').style.display = 'none';

    if (!searchDateFilter) applyCheckInCheckOutDatesIfExisten();
  };

  const applyCheckInCheckOutDatesIfExisten = () => {
    const breakdownPropsEl = document.querySelector('#breakdown-props');
    const presetCheckInString = breakdownPropsEl.getAttribute('data-preset-start-date');
    const presetCheckOutString = breakdownPropsEl.getAttribute('data-preset-end-date');

    if (presetCheckInString.length > 0) {
      datePickCheckinMobile.setDate(parse(presetCheckInString), false);
      datePickCheckinMobile.gotoDate(parse(presetCheckInString));
    }

    if (presetCheckOutString.length > 0) {
      datePickCheckoutMobile.setDate(parse(presetCheckOutString), false);
      datePickCheckoutMobile.gotoDate(parse(presetCheckOutString));
    }

    goToUpdateMobilePreview();
  };

  const handleSeeDatesButton = () => {
    openMobileCalendarModal({});
    createDatePicker();
  };

  seeDatesButtonEls.forEach(btn => {
    btn.addEventListener('click', handleSeeDatesButton);
  });

  datesButton.addEventListener('click', handleSeeDatesButton);
}

const checkInTabHandler = () => {
  showCheckInMessage();
  const checkInEl = document.querySelector('#check-in-tab');
  const checkOutEl = document.querySelector('#check-out-tab');
  document.querySelector('.check-out-container').classList.add('display-none');
  document.querySelector('.check-in-container').classList.remove('display-none');
  checkOutEl.classList.remove('selected');
  checkInEl.classList.add('selected');
  showReservationConfirmSubmit();
};

const checkOutTabHandler = () => {
  showCheckOutMessage();
  const checkOutDate = datePickCheckinMobile.getDate();
  showReservationConfirmSubmit();
  if (checkOutDate) {
    const checkInEl = document.querySelector('#check-in-tab');
    const checkOutEl = document.querySelector('#check-out-tab');
    document.querySelector('.check-out-container').classList.remove('display-none');
    document.querySelector('.check-in-container').classList.add('display-none');
    checkOutEl.classList.add('selected');
    checkInEl.classList.remove('selected');
    const checkOutParsed = Date.parse(checkOutDate.toDateString());
    if (document.querySelector('.check-out-container a[data-time="' + checkOutParsed + '"]')) {
      document.querySelector('.check-out-container a[data-time="' + checkOutParsed + '"]').scrollIntoView(false);
    }
  }
};

const showReservationConfirmSubmit = () => {
  const confirmButton = document.querySelector('#reservation-confirm__submit');
  confirmButton.classList.remove('display-none');
};

const showCheckInMessage = () => {
  document.querySelector('.property-booking-bar__messages').innerText = `${t('apartment_page.js.modal.min_stay')}`;
  document.querySelector('.property-booking-bar__messages').classList.remove('display-none');
};

const showCheckOutMessage = () => {
  document.querySelector('.property-booking-bar__messages').innerText = `${t('apartment_page.js.modal.min_stay')}`;
  document.querySelector('.property-booking-bar__messages').classList.remove('display-none');
};

export default modalReservationForm;

export function goToCheckInTab() {
  document.querySelector('#preview_modal_body').classList.add('display-none');
  document.querySelector('#dates_modal_body').classList.remove('display-none');
  checkInTabHandler();
}

export function goToCheckOutTab() {
  document.querySelector('#preview_modal_body').classList.add('display-none');
  document.querySelector('#dates_modal_body').classList.remove('display-none');
  checkOutTabHandler();
}
